import { app } from '../../../../app';
import { Controller } from './manage-user.controller';

app.component('companyUserDirectoriesManageUser', {
    bindings: {
        companyUser: '<',
    },
    controller: Controller,
    templateUrl: require('./manage-user.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/manage-user.component.js